module.exports = __webpack_public_path__ + "officialStatic/img/pseBg.e16ca78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/pseBg.png
// module id = beaN
// module chunks = 0